import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-72a1884f"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "search-box"
};
const _hoisted_2 = {
  class: "table-container table-box"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1,
  style: {
    "color": "#A2A2A2"
  }
};
const _hoisted_5 = {
  key: 2
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 移除协作者");

const _hoisted_7 = {
  key: 1
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("同意");

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 拒绝");

const _hoisted_10 = {
  class: "footer-btn"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "add-icon"
}, null, -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "添加协作者", -1));

const _hoisted_13 = [_hoisted_11, _hoisted_12];

const _hoisted_14 = /*#__PURE__*/_createTextVNode("完成");

import AddTeamworkerDialog from './AddTeamworkerDialog.vue';
import useConfirm from '@/pages/courseDetail/hooks/useConfirm';
export default {
  props: {
    showAuthListDialog: Boolean,
    authList: Array
  },
  emits: ['update:showAuthListDialog', 'getAuthList'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const siteId = inject('siteId');
    const $http = inject("$http");
    const searchInfo = reactive({
      keyWord: '',
      organ_id: ''
    });
    const orgTreeList = ref([]);
    const orgProps = reactive({
      checkStrictly: true,
      emitPath: false,
      value: 'id',
      label: 'organName'
    });
    const showAddDialog = ref(false);

    const handleClose = () => {
      emit("update:showAuthListDialog", false);
    }; // 获取机构树


    const getOrgTree = async () => {
      const res = await $http.getOrganTree();
      orgTreeList.value = res;
    };

    getOrgTree(); // 搜索

    const handleSearch = () => {
      emit('getAuthList', searchInfo);
    }; // 操作


    const handleOperate = async (data, type) => {
      let params = {
        user_id: data.user_id,
        site_id: siteId,
        status: type
      };

      if (type === -1) {
        // 移除协作者
        useConfirm({
          headerTitle: '提示',
          tipTitle: '确定移除协作者吗？',
          tipText: '移除后将不能协作教案',
          confirmButtonText: '确 定'
        }).then(async () => {
          const res = await $http.addCollaboration(params);

          if (res > 0) {
            ElMessage.success('移除成功');
            emit('getAuthList');
          }
        }).catch(() => {});
      } else if (type === 0) {
        // 拒绝
        useConfirm({
          headerTitle: '提示',
          tipTitle: '确定拒绝协作申请吗？',
          tipText: '拒绝后申请人将不能协作教案',
          confirmButtonText: '确 定'
        }).then(async () => {
          const res = await $http.addCollaboration(params);

          if (res > 0) {
            ElMessage.success('已拒绝');
            emit('getAuthList');
          }
        }).catch(() => {});
      } else {
        const res = await $http.addCollaboration(params);

        if (res > 0) {
          ElMessage.success('已通过');
          emit('getAuthList');
        }
      }
    };

    return (_ctx, _cache) => {
      const _component_search = _resolveComponent("search");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_cascader = _resolveComponent("el-cascader");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: __props.showAuthListDialog,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(showAuthListDialog) ? showAuthListDialog.value = $event : null),
        width: 980,
        "append-to-body": "",
        "before-close": handleClose,
        title: "教案协作者"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
          class: "add-btn",
          onClick: _cache[2] || (_cache[2] = $event => showAddDialog.value = true)
        }, _hoisted_13), _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: handleClose
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
          modelValue: _unref(searchInfo).keyWord,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(searchInfo).keyWord = $event),
          class: "input-box",
          onKeyup: _withKeys(handleSearch, ["native", "enter"]),
          size: "large",
          placeholder: "请输入教师名称"
        }, {
          suffix: _withCtx(() => [_createVNode(_component_el_icon, {
            onClick: handleSearch
          }, {
            default: _withCtx(() => [_createVNode(_component_search)]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue", "onKeyup"]), _createVNode(_component_el_cascader, {
          modelValue: _unref(searchInfo).organ_id,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(searchInfo).organ_id = $event),
          clearable: true,
          onChange: handleSearch,
          "show-all-levels": false,
          options: orgTreeList.value,
          props: _unref(orgProps),
          size: "large",
          style: {
            "width": "236px"
          },
          placeholder: "所属机构"
        }, null, 8, ["modelValue", "options", "props"])]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_table, {
          data: __props.authList,
          height: "300"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            property: "usercode",
            label: "工号",
            align: "center",
            "min-width": "100"
          }), _createVNode(_component_el_table_column, {
            property: "realname",
            label: "姓名",
            align: "center",
            "min-width": "100"
          }), _createVNode(_component_el_table_column, {
            property: "organ_name",
            label: "所属机构",
            align: "center",
            "min-width": "130"
          }), _createVNode(_component_el_table_column, {
            label: "状态",
            align: "center",
            "min-width": "130"
          }, {
            default: _withCtx(scope => [scope.row.status == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_3, "协作者")) : scope.row.status == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "待接受邀请")) : (_openBlock(), _createElementBlock("span", _hoisted_5, "申请协作"))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "130"
          }, {
            default: _withCtx(scope => [scope.row.status == 1 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "text",
              style: {
                "color": "#FF4800"
              },
              onClick: $event => handleOperate(scope.row, -1)
            }, {
              default: _withCtx(() => [_hoisted_6]),
              _: 2
            }, 1032, ["onClick"])) : scope.row.status == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_button, {
              type: "text",
              class: "table-btn",
              onClick: $event => handleOperate(scope.row, 1)
            }, {
              default: _withCtx(() => [_hoisted_8]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              type: "text",
              class: "table-btn",
              style: {
                "color": "#EE8337"
              },
              onClick: $event => handleOperate(scope.row, 0)
            }, {
              default: _withCtx(() => [_hoisted_9]),
              _: 2
            }, 1032, ["onClick"])])) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])])])]),
        _: 1
      }, 8, ["modelValue"]), showAddDialog.value ? (_openBlock(), _createBlock(AddTeamworkerDialog, {
        key: 0,
        show: showAddDialog.value,
        "onUpdate:show": _cache[4] || (_cache[4] = $event => showAddDialog.value = $event),
        onUpdateAuthList: _cache[5] || (_cache[5] = () => emit('getAuthList'))
      }, null, 8, ["show"])) : _createCommentVNode("", true)]);
    };
  }

};